import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children, allowedRole }) {
  const userId = sessionStorage.getItem('userId');
  const role = sessionStorage.getItem('role');
  const isAuthenticated = sessionStorage.getItem('authenticated');

  if (!userId || !isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (allowedRole && role !== allowedRole) {
    return <Navigate to="/" />;
  }

  return children;
}

export default ProtectedRoute;